import { ssoClient,assignmentClient } from "./client";

  const Login=(username,password,appId,selectedrole)=>{
    return ssoClient.post('/User/Login', {
      'username': username,
      'password': password,
      'appId':appId,
      'selectedRole':selectedrole
  });
  }
  const ChangePassword=(oldPass,newPass,newPassReply)=>{
    return ssoClient.post('User/ChangePassword', {

      oldPassword: oldPass,
      password: newPass,
      rePassword: newPassReply

  });
  }
  const GetPermissions=(appid)=>{
    return ssoClient
    .get("Role/GetPermissions",{
      params: {
        'appId': appid
      },
    });

  }
   const GetMenuItems=(appid)=>{
    return ssoClient
    .get("Menu/GetItems", {
  params: {
    'appId': appid
  }});

  }
  const Encrypt=(username,sharedKey)=>{
    return ssoClient
    .post('Misc/Encrypt', {
      'text': username,
      'sharedKey': sharedKey     
  }
    );

  }

  const GetAllGroups=()=>{
  return ssoClient.get('/Misc/GetAllGroups',{

  });
}
const GetSurveyList=(ssn)=>{
  return assignmentClient.get('Survey/GetSurveyBySsn', {
  params: {
    'ssn': ssn
  }
});
}

const RegisterGuest = (firstName, lastName, brokerNo, mobile, username, password, repassword) => {
  return ssoClient.post('User/RegisterGuest', {
    "firstName": firstName,
    "lastName": lastName,
    "brokerNo": brokerNo,
    "mobile": mobile,
    "username": username,
    "password": password,
    "repassword": repassword,
  }
  )
}

const UserApi = { Login,ChangePassword,
  GetMenuItems,GetPermissions,Encrypt,GetAllGroups,GetSurveyList, RegisterGuest}
export default UserApi;
